/**
 * Generated by `shared/scripts/gen-kill-odds.mjs` (`npm run gen:odds`); do not edit.
 * P(kill one target by roll 1..4) from an empty hand, keyed `killer|power` (power '' = none).
 * Computing these cold costs ~0.3 s per pair, so `killOdds` reads this table instead.
 */
export const KILL_ODDS_MAX_ROLLS = 4;
export const KILL_ODDS_TABLE = {
    'p1|': [0.196888, 0.483957, 0.699482, 0.834348],
    'p1|w1': [0.196888, 0.485507, 0.700852, 0.835259],
    'p1|w2': [0.539609, 0.875087, 0.97087, 0.993661],
    'p1|w3': [0.539609, 0.875087, 0.97087, 0.993661],
    'p1|w4': [0.539609, 0.875087, 0.97087, 0.993661],
    'p1|w5': [0.539609, 0.875087, 0.97087, 0.993661],
    'p1|w6': [0.539609, 0.875087, 0.97087, 0.993661],
    'p1|xxx': [0.434156, 0.842353, 0.963019, 0.991952],
    'p1|leq10': [0.434156, 0.841134, 0.962533, 0.991812],
    'p1|geq25': [0.196888, 0.486333, 0.703293, 0.837455],
    'p1|xxxx': [0.212963, 0.516, 0.729162, 0.855388],
    'p1|seq5': [0.227752, 0.526115, 0.734978, 0.859215],
    'p1|e': [0.227752, 0.555483, 0.771597, 0.887506],
    'p1|o': [0.211034, 0.514999, 0.73292, 0.861217],
    'p1|kadice': [0.227752, 0.524966, 0.735859, 0.861276],
    'p2|': [0.196888, 0.483957, 0.699482, 0.834348],
    'p2|w1': [0.539609, 0.875087, 0.97087, 0.993661],
    'p2|w2': [0.196888, 0.485507, 0.700852, 0.835259],
    'p2|w3': [0.539609, 0.875087, 0.97087, 0.993661],
    'p2|w4': [0.539609, 0.875087, 0.97087, 0.993661],
    'p2|w5': [0.539609, 0.875087, 0.97087, 0.993661],
    'p2|w6': [0.539609, 0.875087, 0.97087, 0.993661],
    'p2|xxx': [0.546682, 0.960852, 0.997288, 0.999824],
    'p2|leq10': [0.434156, 0.840897, 0.962425, 0.991779],
    'p2|geq25': [0.434156, 0.841134, 0.962533, 0.991812],
    'p2|xxxx': [0.212963, 0.516, 0.729162, 0.855388],
    'p2|seq5': [0.227752, 0.524966, 0.735859, 0.861276],
    'p2|e': [0.211034, 0.514999, 0.73292, 0.861217],
    'p2|o': [0.227752, 0.555483, 0.771597, 0.887506],
    'p2|kadice': [0.227752, 0.524966, 0.735859, 0.861276],
    'p3|': [0.196888, 0.483957, 0.699482, 0.834348],
    'p3|w1': [0.539609, 0.875087, 0.97087, 0.993661],
    'p3|w2': [0.539609, 0.875087, 0.97087, 0.993661],
    'p3|w3': [0.196888, 0.485507, 0.700852, 0.835259],
    'p3|w4': [0.539609, 0.875087, 0.97087, 0.993661],
    'p3|w5': [0.539609, 0.875087, 0.97087, 0.993661],
    'p3|w6': [0.539609, 0.875087, 0.97087, 0.993661],
    'p3|xxx': [0.546682, 0.960349, 0.997187, 0.999814],
    'p3|leq10': [0.434156, 0.840897, 0.962425, 0.991779],
    'p3|geq25': [0.434156, 0.840897, 0.962425, 0.991779],
    'p3|xxxx': [0.212963, 0.516, 0.729162, 0.855388],
    'p3|seq5': [0.227752, 0.524966, 0.735859, 0.861276],
    'p3|e': [0.227752, 0.555483, 0.771597, 0.887506],
    'p3|o': [0.211034, 0.514999, 0.73292, 0.861217],
    'p3|kadice': [0.227752, 0.526115, 0.734978, 0.859215],
    'p4|': [0.196888, 0.483957, 0.699482, 0.834348],
    'p4|w1': [0.539609, 0.875087, 0.97087, 0.993661],
    'p4|w2': [0.539609, 0.875087, 0.97087, 0.993661],
    'p4|w3': [0.539609, 0.875087, 0.97087, 0.993661],
    'p4|w4': [0.196888, 0.485507, 0.700852, 0.835259],
    'p4|w5': [0.539609, 0.875087, 0.97087, 0.993661],
    'p4|w6': [0.539609, 0.875087, 0.97087, 0.993661],
    'p4|xxx': [0.546682, 0.960349, 0.997187, 0.999814],
    'p4|leq10': [0.434156, 0.840897, 0.962425, 0.991779],
    'p4|geq25': [0.434156, 0.840897, 0.962425, 0.991779],
    'p4|xxxx': [0.212963, 0.516, 0.729162, 0.855388],
    'p4|seq5': [0.227752, 0.524966, 0.735859, 0.861276],
    'p4|e': [0.211034, 0.514999, 0.73292, 0.861217],
    'p4|o': [0.227752, 0.555483, 0.771597, 0.887506],
    'p4|kadice': [0.227752, 0.526115, 0.734978, 0.859215],
    'p5|': [0.196888, 0.483957, 0.699482, 0.834348],
    'p5|w1': [0.539609, 0.875087, 0.97087, 0.993661],
    'p5|w2': [0.539609, 0.875087, 0.97087, 0.993661],
    'p5|w3': [0.539609, 0.875087, 0.97087, 0.993661],
    'p5|w4': [0.539609, 0.875087, 0.97087, 0.993661],
    'p5|w5': [0.196888, 0.485507, 0.700852, 0.835259],
    'p5|w6': [0.539609, 0.875087, 0.97087, 0.993661],
    'p5|xxx': [0.546682, 0.960852, 0.997288, 0.999824],
    'p5|leq10': [0.434156, 0.841134, 0.962533, 0.991812],
    'p5|geq25': [0.434156, 0.840897, 0.962425, 0.991779],
    'p5|xxxx': [0.212963, 0.516, 0.729162, 0.855388],
    'p5|seq5': [0.227752, 0.524966, 0.735859, 0.861276],
    'p5|e': [0.227752, 0.555483, 0.771597, 0.887506],
    'p5|o': [0.211034, 0.514999, 0.73292, 0.861217],
    'p5|kadice': [0.227752, 0.524966, 0.735859, 0.861276],
    'p6|': [0.196888, 0.483957, 0.699482, 0.834348],
    'p6|w1': [0.539609, 0.875087, 0.97087, 0.993661],
    'p6|w2': [0.539609, 0.875087, 0.97087, 0.993661],
    'p6|w3': [0.539609, 0.875087, 0.97087, 0.993661],
    'p6|w4': [0.539609, 0.875087, 0.97087, 0.993661],
    'p6|w5': [0.539609, 0.875087, 0.97087, 0.993661],
    'p6|w6': [0.196888, 0.485507, 0.700852, 0.835259],
    'p6|xxx': [0.434156, 0.842353, 0.963019, 0.991952],
    'p6|leq10': [0.196888, 0.486333, 0.703293, 0.837455],
    'p6|geq25': [0.434156, 0.841134, 0.962533, 0.991812],
    'p6|xxxx': [0.212963, 0.516, 0.729162, 0.855388],
    'p6|seq5': [0.227752, 0.526115, 0.734978, 0.859215],
    'p6|e': [0.211034, 0.514999, 0.73292, 0.861217],
    'p6|o': [0.227752, 0.555483, 0.771597, 0.887506],
    'p6|kadice': [0.227752, 0.524966, 0.735859, 0.861276],
    'xxyy|': [0.270833, 0.56115, 0.742754, 0.849824],
    'xxyy|w1': [0.659851, 0.885392, 0.961778, 0.987259],
    'xxyy|w2': [0.659851, 0.885392, 0.961778, 0.987259],
    'xxyy|w3': [0.659851, 0.885392, 0.961778, 0.987259],
    'xxyy|w4': [0.659851, 0.885392, 0.961778, 0.987259],
    'xxyy|w5': [0.659851, 0.885392, 0.961778, 0.987259],
    'xxyy|w6': [0.659851, 0.885392, 0.961778, 0.987259],
    'xxyy|xxx': [0.771091, 0.991177, 0.999951, 1],
    'xxyy|leq10': [0.737011, 0.94789, 0.990323, 0.998219],
    'xxyy|geq25': [0.737011, 0.94789, 0.990323, 0.998219],
    'xxyy|xxxx': [0.290123, 0.591335, 0.771641, 0.873011],
    'xxyy|seq5': [0.301698, 0.585941, 0.758093, 0.858867],
    'xxyy|e': [0.282407, 0.592389, 0.777067, 0.878476],
    'xxyy|o': [0.282407, 0.592389, 0.777067, 0.878476],
    'xxyy|kadice': [0.301698, 0.585941, 0.758093, 0.858867],
    'xxx|': [0.212963, 0.541324, 0.743195, 0.857147],
    'xxx|w1': [0.637346, 0.897953, 0.971633, 0.99212],
    'xxx|w2': [0.637346, 0.897953, 0.971633, 0.99212],
    'xxx|w3': [0.637346, 0.897953, 0.971633, 0.99212],
    'xxx|w4': [0.637346, 0.897953, 0.971633, 0.99212],
    'xxx|w5': [0.637346, 0.897953, 0.971633, 0.99212],
    'xxx|w6': [0.637346, 0.897953, 0.971633, 0.99212],
    'xxx|xxx': [0.768519, 0.985854, 0.999525, 0.999992],
    'xxx|leq10': [0.583333, 0.900817, 0.976521, 0.994451],
    'xxx|geq25': [0.583333, 0.900817, 0.976521, 0.994451],
    'xxx|xxxx': [0.212963, 0.541324, 0.743195, 0.857147],
    'xxx|seq5': [0.243827, 0.567901, 0.759278, 0.866229],
    'xxx|e': [0.224537, 0.564686, 0.767917, 0.87855],
    'xxx|o': [0.224537, 0.564686, 0.767917, 0.87855],
    'xxx|kadice': [0.243827, 0.567901, 0.759278, 0.866229],
    'xxxx|': [0.0200617, 0.132302, 0.290794, 0.448007],
    'xxxx|w1': [0.187243, 0.53021, 0.760951, 0.885351],
    'xxxx|w2': [0.187243, 0.53021, 0.760951, 0.885351],
    'xxxx|w3': [0.187243, 0.53021, 0.760951, 0.885351],
    'xxxx|w4': [0.187243, 0.53021, 0.760951, 0.885351],
    'xxxx|w5': [0.187243, 0.53021, 0.760951, 0.885351],
    'xxxx|w6': [0.187243, 0.53021, 0.760951, 0.885351],
    'xxxx|xxx': [0.125514, 0.645097, 0.889555, 0.97004],
    'xxxx|leq10': [0.0779321, 0.433942, 0.708391, 0.860789],
    'xxxx|geq25': [0.0779321, 0.433942, 0.708391, 0.860789],
    'xxxx|xxxx': [0.0200617, 0.132302, 0.290794, 0.448007],
    'xxxx|seq5': [0.0509259, 0.204175, 0.368314, 0.515938],
    'xxxx|e': [0.0470679, 0.282836, 0.551172, 0.744256],
    'xxxx|o': [0.0470679, 0.282836, 0.551172, 0.744256],
    'xxxx|kadice': [0.0509259, 0.204175, 0.368314, 0.515938],
    'xxxyy|': [0.0393519, 0.194102, 0.366145, 0.513995],
    'xxxyy|w1': [0.235468, 0.563462, 0.769085, 0.879931],
    'xxxyy|w2': [0.235468, 0.563462, 0.769085, 0.879931],
    'xxxyy|w3': [0.235468, 0.563462, 0.769085, 0.879931],
    'xxxyy|w4': [0.235468, 0.563462, 0.769085, 0.879931],
    'xxxyy|w5': [0.235468, 0.563462, 0.769085, 0.879931],
    'xxxyy|w6': [0.235468, 0.563462, 0.769085, 0.879931],
    'xxxyy|xxx': [0.236111, 0.754372, 0.936885, 0.983803],
    'xxxyy|leq10': [0.171168, 0.598015, 0.815243, 0.916078],
    'xxxyy|geq25': [0.171168, 0.598015, 0.815243, 0.916078],
    'xxxyy|xxxx': [0.058642, 0.28698, 0.519123, 0.690149],
    'xxxyy|seq5': [0.070216, 0.256044, 0.421689, 0.567179],
    'xxxyy|e': [0.0625, 0.3107, 0.565349, 0.75181],
    'xxxyy|o': [0.0625, 0.3107, 0.565349, 0.75181],
    'xxxyy|kadice': [0.070216, 0.256044, 0.421689, 0.567179],
    'seq4|': [0.155093, 0.412657, 0.616025, 0.759229],
    'seq4|w1': [0.4991, 0.786992, 0.919443, 0.971686],
    'seq4|w2': [0.414223, 0.72513, 0.881716, 0.951271],
    'seq4|w3': [0.298483, 0.623064, 0.818046, 0.91809],
    'seq4|w4': [0.298483, 0.623064, 0.818046, 0.91809],
    'seq4|w5': [0.414223, 0.72513, 0.881716, 0.951271],
    'seq4|w6': [0.4991, 0.786992, 0.919443, 0.971686],
    'seq4|xxx': [0.571759, 0.935524, 0.994692, 0.999638],
    'seq4|leq10': [0.39429, 0.776885, 0.931911, 0.981344],
    'seq4|geq25': [0.39429, 0.776885, 0.931911, 0.981344],
    'seq4|xxxx': [0.174383, 0.442456, 0.641097, 0.781358],
    'seq4|seq5': [0.155093, 0.412657, 0.616025, 0.759229],
    'seq4|e': [0.185957, 0.478911, 0.698255, 0.837612],
    'seq4|o': [0.185957, 0.478911, 0.698255, 0.837612],
    'seq4|kadice': [0.185957, 0.467072, 0.67375, 0.803172],
    'seq5|': [0.0316358, 0.132935, 0.265319, 0.394344],
    'seq5|w1': [0.19946, 0.433983, 0.614341, 0.740756],
    'seq5|w2': [0.112011, 0.332917, 0.53398, 0.695399],
    'seq5|w3': [0.112011, 0.332917, 0.53398, 0.695399],
    'seq5|w4': [0.112011, 0.332917, 0.53398, 0.695399],
    'seq5|w5': [0.112011, 0.332917, 0.53398, 0.695399],
    'seq5|w6': [0.19946, 0.433983, 0.614341, 0.740756],
    'seq5|xxx': [0.185957, 0.5788, 0.810687, 0.923163],
    'seq5|leq10': [0.108796, 0.375605, 0.597797, 0.75447],
    'seq5|geq25': [0.108796, 0.375605, 0.597797, 0.75447],
    'seq5|xxxx': [0.0509259, 0.204175, 0.368314, 0.515938],
    'seq5|seq5': [0.0316358, 0.132935, 0.265319, 0.394344],
    'seq5|e': [0.0625, 0.287688, 0.54923, 0.745973],
    'seq5|o': [0.0625, 0.287688, 0.54923, 0.745973],
    'seq5|kadice': [0.0625, 0.222036, 0.385231, 0.526083],
    'e|': [0.0316358, 0.238814, 0.513545, 0.724406],
    'e|w1': [0.131944, 0.559897, 0.830099, 0.940519],
    'e|w2': [0.0316358, 0.25087, 0.523513, 0.72925],
    'e|w3': [0.131944, 0.559897, 0.830099, 0.940519],
    'e|w4': [0.0316358, 0.25087, 0.523513, 0.72925],
    'e|w5': [0.131944, 0.559897, 0.830099, 0.940519],
    'e|w6': [0.0316358, 0.25087, 0.523513, 0.72925],
    'e|xxx': [0.187886, 0.824138, 0.992324, 0.99994],
    'e|leq10': [0.135802, 0.677507, 0.933572, 0.988483],
    'e|geq25': [0.187886, 0.823174, 0.992264, 0.99994],
    'e|xxxx': [0.0470679, 0.282836, 0.551172, 0.744256],
    'e|seq5': [0.0625, 0.287688, 0.54923, 0.745973],
    'e|e': [0.0316358, 0.238814, 0.513545, 0.724406],
    'e|o': [0.0625, 0.375, 0.648438, 0.814453],
    'e|kadice': [0.0625, 0.287688, 0.54923, 0.745973],
    'o|': [0.0316358, 0.238814, 0.513545, 0.724406],
    'o|w1': [0.0316358, 0.25087, 0.523513, 0.72925],
    'o|w2': [0.131944, 0.559897, 0.830099, 0.940519],
    'o|w3': [0.0316358, 0.25087, 0.523513, 0.72925],
    'o|w4': [0.131944, 0.559897, 0.830099, 0.940519],
    'o|w5': [0.0316358, 0.25087, 0.523513, 0.72925],
    'o|w6': [0.131944, 0.559897, 0.830099, 0.940519],
    'o|xxx': [0.187886, 0.824138, 0.992324, 0.99994],
    'o|leq10': [0.187886, 0.823174, 0.992264, 0.99994],
    'o|geq25': [0.135802, 0.677507, 0.933572, 0.988483],
    'o|xxxx': [0.0470679, 0.282836, 0.551172, 0.744256],
    'o|seq5': [0.0625, 0.287688, 0.54923, 0.745973],
    'o|e': [0.0625, 0.375, 0.648438, 0.814453],
    'o|o': [0.0316358, 0.238814, 0.513545, 0.724406],
    'o|kadice': [0.0625, 0.287688, 0.54923, 0.745973],
    'leq10|': [0.0329218, 0.191605, 0.418549, 0.623448],
    'leq10|w1': [0.0329218, 0.20125, 0.428659, 0.630066],
    'leq10|w2': [0.0766461, 0.348561, 0.628705, 0.816634],
    'leq10|w3': [0.119084, 0.476148, 0.753513, 0.897367],
    'leq10|w4': [0.149949, 0.535669, 0.801363, 0.924488],
    'leq10|w5': [0.185957, 0.584977, 0.838519, 0.944901],
    'leq10|w6': [0.206533, 0.621763, 0.859879, 0.954085],
    'leq10|xxx': [0.059285, 0.37958, 0.716505, 0.895431],
    'leq10|leq10': [0.059285, 0.376175, 0.710287, 0.892841],
    'leq10|geq25': [0.0329218, 0.198698, 0.431868, 0.635576],
    'leq10|xxxx': [0.0483539, 0.25018, 0.487933, 0.681152],
    'leq10|seq5': [0.063786, 0.259686, 0.478691, 0.667306],
    'leq10|e': [0.063786, 0.328085, 0.602997, 0.787826],
    'leq10|o': [0.061214, 0.315155, 0.585614, 0.773858],
    'leq10|kadice': [0.063786, 0.25099, 0.472182, 0.662544],
    'geq25|': [0.0329218, 0.191605, 0.418549, 0.623448],
    'geq25|w1': [0.206533, 0.621763, 0.859879, 0.954085],
    'geq25|w2': [0.185957, 0.584977, 0.838519, 0.944901],
    'geq25|w3': [0.149949, 0.535669, 0.801363, 0.924488],
    'geq25|w4': [0.119084, 0.476148, 0.753513, 0.897367],
    'geq25|w5': [0.0766461, 0.348561, 0.628705, 0.816634],
    'geq25|w6': [0.0329218, 0.20125, 0.428659, 0.630066],
    'geq25|xxx': [0.059285, 0.37958, 0.716505, 0.895431],
    'geq25|leq10': [0.0329218, 0.198698, 0.431868, 0.635576],
    'geq25|geq25': [0.059285, 0.376175, 0.710287, 0.892841],
    'geq25|xxxx': [0.0483539, 0.25018, 0.487933, 0.681152],
    'geq25|seq5': [0.063786, 0.259686, 0.478691, 0.667306],
    'geq25|e': [0.061214, 0.315155, 0.585614, 0.773858],
    'geq25|o': [0.063786, 0.328085, 0.602997, 0.787826],
    'geq25|kadice': [0.063786, 0.25099, 0.472182, 0.662544],
    'kadice|': [0.0316358, 0.132935, 0.265319, 0.394344],
    'kadice|w1': [0.112011, 0.332917, 0.53398, 0.695399],
    'kadice|w2': [0.112011, 0.332917, 0.53398, 0.695399],
    'kadice|w3': [0.19946, 0.433983, 0.614341, 0.740756],
    'kadice|w4': [0.19946, 0.433983, 0.614341, 0.740756],
    'kadice|w5': [0.112011, 0.332917, 0.53398, 0.695399],
    'kadice|w6': [0.112011, 0.332917, 0.53398, 0.695399],
    'kadice|xxx': [0.155093, 0.504174, 0.749675, 0.885397],
    'kadice|leq10': [0.0933642, 0.317515, 0.523572, 0.682727],
    'kadice|geq25': [0.0933642, 0.317515, 0.523572, 0.682727],
    'kadice|xxxx': [0.0509259, 0.204175, 0.368314, 0.515938],
    'kadice|seq5': [0.0625, 0.222036, 0.385231, 0.526083],
    'kadice|e': [0.0625, 0.287688, 0.54923, 0.745973],
    'kadice|o': [0.0625, 0.287688, 0.54923, 0.745973],
    'kadice|kadice': [0.0316358, 0.132935, 0.265319, 0.394344],
};
//# sourceMappingURL=killOddsTable.js.map